export default "__VITE_ASSET__adc8a228__"